import { StarIcon as PiStar } from '@phosphor-icons/react'
import styled from 'styled-components'

export const Star = styled(PiStar)`
  color: ${props => (props.selected ? props.theme.colors.orange.tone500 : props.theme.colors.green.tone900)};

  &:hover {
    cursor: pointer;
  }
`
